var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailAroowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6208A0E5-CDCE-458C-AC5E-EEDBFA60A2A8@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Sign-In-Filled-Out",
    transform: "translate(-562.000000, -337.000000)",
    fill: "#2774AE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(269.000000, 317.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-:-arrow-fill",
    transform: "translate(293.500000, 20.500000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "icon",
    points: "5.625 9 11.25 0 0 0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailAroowDown);
export default __webpack_public_path__ + "static/media/EmailAroowDown.55001fc8a4aee7fc2df415a1c8efb42e.svg";
export { ForwardRef as ReactComponent };